import { jwtDecode } from 'jwt-decode';

import { TokenData } from '../interfaces/TokenData';
import { UserRole } from '../interfaces/User';

const LOCAL_STORAGE_KEY = 'sps-auth-token';

interface AuthJwtPayload {
  username?: string;
  sub?: string;
  roles?: UserRole[] | string[];

  institution?: number[];
  institutions?: number[];

  department?: number[];
  departments?: number[];

  departmentSection?: number[];
  department_sections?: number[];

  iat?: number;
  exp?: number;
}

export const getStoredAuthToken = (): string | null =>
  localStorage.getItem(LOCAL_STORAGE_KEY);

export const storeAuthToken = (token?: string) => {
  if (token) {
    localStorage.setItem(LOCAL_STORAGE_KEY, token);
  } else {
    localStorage.removeItem(LOCAL_STORAGE_KEY);
  }
};

export const clearAuthToken = () => {
  localStorage.removeItem(LOCAL_STORAGE_KEY);
};

export const isTokenExpired = (token: string): boolean => {
  try {
    const payload = jwtDecode<AuthJwtPayload>(token);

    if (!payload.exp) {
      return true;
    }

    const nowInSeconds = Math.floor(Date.now() / 1000);

    return payload.exp <= nowInSeconds;
  } catch {
    return true;
  }
};

export const getTokenDataFromStoredToken = (): TokenData | null => {
  const token = getStoredAuthToken();

  if (!token) {
    return null;
  }

  try {
    const payload = jwtDecode<AuthJwtPayload>(token);

    if (!payload.exp) {
      clearAuthToken();
      return null;
    }

    const nowInSeconds = Math.floor(Date.now() / 1000);

    if (payload.exp <= nowInSeconds) {
      clearAuthToken();
      return null;
    }

    return {
      username: payload.username ?? payload.sub ?? '',
      roles: (payload.roles ?? []) as UserRole[],
      institution: payload.institution ?? payload.institutions ?? [],
      department: payload.department ?? payload.departments ?? [],
      departmentSection:
        payload.departmentSection ?? payload.department_sections ?? [],
    };
  } catch {
    clearAuthToken();
    return null;
  }
};
